<!----
    Author: hjlee
    Description:
        개정된 약관 모달
---->
<template>
  <b-modal
    v-if="loggedInUser"
    id="revised-stipulation-modal"
    ref="modalRef"
    size="xl"
    modal-class="simple-design"
    :ok-only="true"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    :hide-header-close="true"
    :title="$t('common.title.revised_stipulation')"
    :ok-title="$t('common.button.ok')"
    scrollable
    @ok="confirm"
  >
    <div v-if="!loggedInUser.nm" class="stipulation-container">
      <div class="clear" />
      <div class="stipulation-title">
        {{ $t('stipulation.text.required_fields') }}
        <span class="required-stipulation">*</span>
      </div>
      <input-control
        v-model="nm"
        type="text"
        name="nm"
        class="nm-input-control"
        :title="$t('column.nm.nm')"
        :placeholder="$t('stipulation.placeholder.nm')"
        :no-title="true"
      />
    </div>
    <div v-for="(stipulation, stipulationIndex) in loggedInUser.revisedStipulations" :key="stipulationIndex" class="stipulation-container">
      <div class="clear" />
      <div class="stipulation-title">
        {{ stipulation.title }}
        <span v-if="stipulation.esntlFlag === 'Y'">({{ $t('common.text.required') }})</span>
        <span v-else>({{ $t('common.text.optional') }})</span>
        <span v-if="stipulation.esntlFlag === 'Y'" class="required-stipulation">*</span>
      </div>
      <div class="stipulation-contents" v-html="stipulation.cn" />
      <div class="stipulation-control">
        <b-form-checkbox
          :id="'stipulation-' + stipulation.id"
          v-model="checkedStipulations"
          type="checkbox"
          :name="'stipulation-' + stipulation.id"
          :required="stipulation.esntlFlag === 'Y'"
          :value="stipulation.id"
        >
          {{ $t('stipulation.button.agree') }}
        </b-form-checkbox>
      </div>
      <div class="clear" />
    </div>
    <div class="stipulation-all-control">
      <b-button variant="outline-secondary" class="btn-default" @click="agreeAll">
        {{ $t('stipulation.button.agree_all') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      checkedStipulations: [],
      nm: ''
    }
  },
  watch: {
    loggedInUser: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.showIfRevisedStipulations()
        }
      },
      deep: true
    }
  },
  mounted() {
    this.showIfRevisedStipulations()
  },
  methods: {
    showIfRevisedStipulations() {
      if (
        this.loggedInUser &&
        this.loggedInUser.revisedStipulations &&
        this.loggedInUser.revisedStipulations.length > 0 &&
        this.loggedInUser.userId !== 'developer' &&
        this.loggedInUser.userId !== 'superadmin' &&
        this.loggedInUser.userId !== 'admin'
      ) {
        this.$nextTick(() => {
          this.showModal('modalRef')
        })
      }
    },
    agreeAll() {
      this.checkedStipulations = []
      for (let i = 0; i < this.loggedInUser.revisedStipulations.length; i++) {
        this.checkedStipulations.push(
          this.loggedInUser.revisedStipulations[i].id
        )
      }
      this.$forceUpdate()
    },
    confirm(e) {
      e.preventDefault()
      if (!this.loggedInUser.nm && !this.nm) {
        this.$toast.info(this.$t('stipulation.placeholder.nm'))
        $('.nm-input-control input[type=text]').focus()
        return
      }

      // 필수 약관 체크
      for (let i = 0; i < this.loggedInUser.revisedStipulations.length; i++) {
        const revisedStipulationId = this.loggedInUser.revisedStipulations[i].id
        if (this.loggedInUser.revisedStipulations[i].esntlFlag !== 'Y') {
          continue
        }
        let found = false
        for (let j = 0; j < this.checkedStipulations.length; j++) {
          const checked = this.checkedStipulations[j]
          if (revisedStipulationId === checked) {
            found = true
            break
          }
        }
        if (!found) {
          this.$toast.info(this.$t('stipulation.warning.required_is_missing'))
          return
        }
      }
      const agreedStipulations = []
      const disagreedStipulations = []
      for (let i = 0; i < this.loggedInUser.revisedStipulations.length; i++) {
        const revisedStipulationId = this.loggedInUser.revisedStipulations[i].id
        let found = false
        for (let j = 0; j < this.checkedStipulations.length; j++) {
          const checked = this.checkedStipulations[j]
          if (revisedStipulationId === checked) {
            found = true
            break
          }
        }
        if (found) {
          agreedStipulations.push(revisedStipulationId)
        } else {
          disagreedStipulations.push(revisedStipulationId)
        }
      }

      this.$axios
        .$post('/stipulation/confirmStipulations', {
          agreedStipulations: agreedStipulations,
          disagreedStipulations: disagreedStipulations,
          nm: this.nm
        })
        .then(response => {
          if (response.resultCode === 'success') {
            this.hideModal('modalRef')
          } else {
            console.error(this.$t(response.message))
            this.$toast.error(this.$t(response.message))
          }
        })
    }
  }
}
</script>

<style scope>
.stipulation-title {
  font-size: 1.1rem;
  font-weight: bold;
}
.stipulation-contents {
  border: 1px solid #cccccc;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 10px;
  margin-top: 5px;
  max-height: 200px;
  overflow-y: auto;
}
.required-stipulation {
  color: red;
}
.stipulation-control {
  text-align: right;
}
.stipulation-all-control {
  text-align: center;
}
h5.modal-title {
  font-size: 1.8rem !important;
}
.stipulation-container {
  margin: 1rem 0;
}
.stipulation-container:first-child {
  margin-top: 0;
}
</style>
